import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise'
import multi from 'redux-multi'

import rootReducer from './reducers/root.reducer'

let middleware = [multi, thunk, promise];

export const store = createStore(rootReducer, applyMiddleware(...middleware))